var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilegov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#2D97E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31V29C30 27.9391 29.5786 26.9217 28.8284 26.1716C28.0783 25.4214 27.0609 25 26 25H18C16.9391 25 15.9217 25.4214 15.1716 26.1716C14.4214 26.9217 14 27.9391 14 29V31M26 17C26 19.2091 24.2091 21 22 21C19.7909 21 18 19.2091 18 17C18 14.7909 19.7909 13 22 13C24.2091 13 26 14.7909 26 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilegov);
export default __webpack_public_path__ + "static/media/profile.gov.e914c92383d04041261b1735ccbded27.svg";
export { ForwardRef as ReactComponent };